declare namespace $ {

	export class $mol_icon_chat extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=chat.view.tree.d.ts.map